import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

import DemoAdmin from 'src/pages/dashboard/admin-dashboard/admin-users/demo';
import LeadsAdmin from 'src/pages/dashboard/admin-dashboard/admin-users/leads';
import MarketingAdmin from 'src/pages/dashboard/admin-dashboard/admin-users/marketing';
import SalesAdmin from 'src/pages/dashboard/admin-dashboard/admin-users/sales';
import TechnicalAdmin from 'src/pages/dashboard/admin-dashboard/admin-users/technical';
import BlogsProduct from 'src/pages/dashboard/admin-dashboard/product-updates/blogs';
import Createblogs from 'src/pages/dashboard/admin-dashboard/product-updates/blogs/create-blogs';
import GeneralProduct from 'src/pages/dashboard/admin-dashboard/product-updates/general';
import Creategeneral from 'src/pages/dashboard/admin-dashboard/product-updates/general/create-general';
import MaintainaceProduct from 'src/pages/dashboard/admin-dashboard/product-updates/maintainance';
import CreateMaintainace from 'src/pages/dashboard/admin-dashboard/product-updates/maintainance/create-maintainace';
import NewsLetter from 'src/pages/dashboard/admin-dashboard/product-updates/newsletter';
import CreateNewsLetter from 'src/pages/dashboard/admin-dashboard/product-updates/newsletter/create-news-letter';
import OffersProduct from 'src/pages/dashboard/admin-dashboard/product-updates/offers';
import Createoffers from 'src/pages/dashboard/admin-dashboard/product-updates/offers/create-offers';
import ProductFeatures from 'src/pages/dashboard/admin-dashboard/product-updates/product-features';
import CreateProductfeatures from 'src/pages/dashboard/admin-dashboard/product-updates/product-features/create-product-features';
import SupportTickets from 'src/pages/dashboard/admin-dashboard/support-tickets';

import OthersAdmin from 'src/pages/dashboard/admin-dashboard/admin-users/others';
import VendorUserShowPage from 'src/pages/dashboard/admin-dashboard/ezelogs-user/vendor-user/vendor-user-show-page';
import TechnicalBids from 'src/pages/dashboard/admin-dashboard/technical-database/bids';
import CostCodes from 'src/pages/dashboard/admin-dashboard/technical-database/cost-codes';
import CostCodesListShow from 'src/pages/dashboard/admin-dashboard/technical-database/cost-codes/costCodes-show-page';
import TechnicalEquipments from 'src/pages/dashboard/admin-dashboard/technical-database/equipments';
import EquipmentsListShow from 'src/pages/dashboard/admin-dashboard/technical-database/equipments/equipments-show-page';
import TechnicalMaterials from 'src/pages/dashboard/admin-dashboard/technical-database/materials';
import MaterialsListShow from 'src/pages/dashboard/admin-dashboard/technical-database/materials/materials-show-page';
import SttFolders from 'src/pages/dashboard/admin-dashboard/technical-database/stt-folders';
import SttFolderListShow from 'src/pages/dashboard/admin-dashboard/technical-database/stt-folders/stt-folders-show-page';
import TechnicalTrades from 'src/pages/dashboard/admin-dashboard/technical-database/trades';
import TechnicalTradesWorkTitle from 'src/pages/dashboard/admin-dashboard/technical-database/trades-work-title';
import OverviewEcommercePage from 'src/pages/dashboard/adminuser';
import ProductModuduleFeatures from 'src/pages/dashboard/admin-dashboard/product-packages/module-features';
import AllAdmin from 'src/pages/dashboard/admin-dashboard/admin-users/all-admin-users';
import { PlanCreatePage } from 'src/pages/dashboard/admin-dashboard/product-packages/plans/plan-create-page';
import { PlanCreateAddonPage } from 'src/pages/dashboard/admin-dashboard/product-packages/plans/plans-add-on-page';
import { PlanAddonViewPage } from 'src/pages/dashboard/admin-dashboard/product-packages/plans/plan-add-on-view-page';
import MarketingDashboard from 'src/pages/dashboard/admin-dashboard/marketing-management/dashboard';
import MarketingTools from 'src/pages/dashboard/admin-dashboard/marketing-management/marketing-tools';
import MarketingList from 'src/pages/dashboard/admin-dashboard/marketing-management/list';
import MarketingBoards from 'src/pages/dashboard/admin-dashboard/marketing-management/boards';
import MarketingTimeline from '../../pages/dashboard/admin-dashboard/marketing-management/timeline';
import HomePage from 'src/pages/dashboard/admin-dashboard/cms-management/website-pages';



// ----------------------------------------------------------------------
// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/admin-dashboard/dashboard/dashboard'));
const RegisterUser = lazy(() =>
  import('src/pages/dashboard/admin-dashboard/ezelogs-user/register-user')
);
const VendorUser = lazy(() =>
  import('src/pages/dashboard/admin-dashboard/ezelogs-user/vendor-user')
);
const RoleAndPermission = lazy(() =>
  import('src/pages/dashboard/admin-dashboard/role-and-permission')
);
const CreateRoleAndPermission = lazy(() =>
  import('src/pages/dashboard/admin-dashboard/role-and-permission/create-role-perission')
);
const BillingAndInvoices = lazy(() =>
  import('src/pages/dashboard/admin-dashboard/billing-and-invoices')
);
const CreateBillingAndInvoice = lazy(() =>
  import('src/pages/dashboard/admin-dashboard/billing-and-invoices/create-billing-invoice')
);

const ProductPlans = lazy(() =>
  import('src/pages/dashboard/admin-dashboard/product-packages/plans')
);
const NewUserAdmin = lazy(() => import('src/pages/dashboard/admin-dashboard/admin-users/new-user'));
const AssestsIndex = lazy(() => import('src/pages/dashboard/admin-dashboard/cms-management/assests/assests-index'));





export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={ <LoadingScreen /> }>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),

    children: [
      //dashboard


      { element: <IndexPage />, index: true },


      // USER
      { path: '/dashboard/adminuser', element: <OverviewEcommercePage /> },
      { path: 'ezelogs-user/register-user', element: <RegisterUser /> },
      { path: 'ezelogs-user/vendor-user', element: <VendorUser /> },
      { path: 'vendor-user/vendor-user-show-page/:id', element: <VendorUserShowPage /> },
      // roles and permissions
      { path: 'role-and-permission', element: <RoleAndPermission /> },
      { path: 'role-and-permission/create-role-perission', element: <CreateRoleAndPermission /> },
      // billing and invoices
      { path: 'billing-and-invoice', element: <BillingAndInvoices /> },
      { path: 'billing-and-invoice/create-billing-invoice', element: <CreateBillingAndInvoice /> },
      // project packages/plans
      // { path: 'product-packages/basic-cost', element: <ProductBasicCost /> },
      { path: 'product-packages/module-features', element: <ProductModuduleFeatures /> },
      { path: 'product-packages/plans', element: <ProductPlans /> },
      { path: 'product-packages/plans/plan-create-page', element: <PlanCreatePage /> },
      { path: 'product-packages/plans/plans-add-on-page/:id', element: <PlanCreateAddonPage /> },
      { path: 'product-packages/plans/plan-add-on-view-page', element: <PlanAddonViewPage /> },

      //admin users
      { path: 'admin-users/all-admin-users', element: <AllAdmin /> },
      { path: 'admin-users/new-user', element: <NewUserAdmin /> },
      { path: 'admin-users/marketing', element: <MarketingAdmin /> },
      { path: 'admin-users/leads', element: <LeadsAdmin /> },
      { path: 'admin-users/sales', element: <SalesAdmin /> },
      { path: 'admin-users/demo', element: <DemoAdmin /> },
      { path: 'admin-users/technical', element: <TechnicalAdmin /> },
      { path: 'admin-users/others', element: <OthersAdmin /> },

      //marketing mangement

      { path: 'marketing-management/dashboard', element: <MarketingDashboard /> },
      { path: 'marketing-management/marketing-tools', element: <MarketingTools /> },
      { path: 'marketing-management/boards', element: <MarketingBoards /> },
      { path: 'marketing-management/list', element: <MarketingList /> },
      { path: 'marketing-management/timeline', element: <MarketingTimeline /> },

      //support-tickets
      { path: 'support-tickets', element: <SupportTickets /> },
      //product routes
      { path: 'product-updates/newsletter', element: <NewsLetter /> },
      { path: 'product-updates/newsletter/create-news-letter', element: <CreateNewsLetter /> },
      //MaintainaceProduct
      { path: 'product-updates/maintainance', element: <MaintainaceProduct /> },
      { path: 'product-updates/maintainance/create-maintainace', element: <CreateMaintainace /> },
      //OffersProduct
      { path: 'product-updates/offers', element: <OffersProduct /> },
      { path: 'product-updates/offers/create-offers', element: <Createoffers /> },
      //BlogsProduct
      { path: 'product-updates/blogs', element: <BlogsProduct /> },
      { path: 'product-updates/blogs/create-blogs', element: <Createblogs /> },
      //GeneralProduct
      { path: 'product-updates/general', element: <GeneralProduct /> },
      { path: 'product-updates/general/create-general', element: <Creategeneral /> },
      //ProductFeatures
      { path: 'product-updates/product-features', element: <ProductFeatures /> },
      { path: 'product-updates/product-features/create-product-features', element: <CreateProductfeatures /> },
      //ProductFeatures
      { path: 'technical-database/cost-codes', element: <CostCodes /> },
      { path: 'technical-database/cost-codes/costCodes-show-page/:id', element: <CostCodesListShow /> },
      //ProductFeatures
      { path: 'technical-database/material', element: <TechnicalMaterials /> },
      { path: 'technical-database/materials/materials-show-page/:id', element: <MaterialsListShow /> },
      //TechnicalEquipments
      { path: 'technical-database/equipments', element: <TechnicalEquipments /> },
      { path: 'technical-database/equipments/equipments-show-page/:id', element: <EquipmentsListShow /> },
      //TechnicalTrades
      { path: 'technical-database/trades', element: <TechnicalTrades /> },
      //TechnicalTradesWorkTitle
      { path: 'technical-database/trades-work-title', element: <TechnicalTradesWorkTitle /> },
      //TechnicalTradesWorkTitle
      { path: 'technical-database/bids', element: <TechnicalBids /> },
      //SttFolders
      { path: 'technical-database/stt-folders', element: <SttFolders /> },
      { path: 'technical-database/stt-folders/stt-folders-show-page/:id', element: <SttFolderListShow /> },

      //CMS Management

      { path: 'cms-management/website-pages', element: <HomePage /> },
      { path: 'cms-management/assests', element: <AssestsIndex /> },


    ],
  },
];
